<template>
  <div class="getCode loginCom">
    <returnPage @getCodeReturn="getCodeReturn" type="getCode" v-if="!this.$root.miniprogram" />

    <div class="getCodeMain loginMmain">
      <div class="getCodeMain_title">输入验证码</div>
      <div class="getCodeMain_describe">
        短信验证码已发送至{{ userPhone ? userPhone : '您的手机' }}
      </div>
    </div>
    <CodeInput :clearIpt="isFlag" :loginType="loginWay" :yuntuColor="yuntuColor"></CodeInput>

    <div class="resetGetCode" :class="{ yuntuColor: yuntuColor }">
      <div
        :class="{ getCodeText: residueTime > '59' ? false : true, activeClass: isFlag }"
        @click="getCodeBtn()"
      >
        <span>{{ getCodeTime }}</span>
        <span :class="{ idNone: residueTime <= '59' ? false : true }"
          >（{{ this.residueTime }}）</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import returnPage from '@/components/login/returnPage.vue';
import '@/assets/css/loginCommon.css';
import CodeInput from '@/components/login/codeInput2.vue';
import { queryCode } from '@/api/login';
// eslint-disable-next-line import/order
import { Toast } from 'vant';

export default {
  components: {
    returnPage,
    CodeInput,
  },
  data() {
    return {
      getCodeTime: '重新获取',
      isFlag: true,
      residueTime: 59,
      code: [],
      timer: null,
      requestCode: true,
      yuntuColor: false,
    };
  },

  methods: {
    getCodeReturn() {
      if (this.loginWay === 'login') {
        this.$router.replace({
          path: '/registrationLogin',
          query: JSON.parse(this.urlParams),
          params: JSON.parse(this.pagesParams),
        });
      } else if (this.loginWay === 'forgetPassword') {
        this.$router.replace({
          path: '/retrievePassword',
          query: JSON.parse(this.urlParams),
          params: JSON.parse(this.pagesParams),
        });
      }
    },
    // 倒计时
    getCodeBtn() {
      // if (!this.isFlag) return;
      if (!this.requestCode) return;

      this.getCode();
    },
    getCode() {
      this.isFlag = true;
      this.requestCode = true;
      this.residueTime = 59;
      clearInterval(this.timer);
      this.timer = null;
      if (this.loginWay === 'login') {
        this.$router.replace({
          path: '/registrationLogin',
          query: JSON.parse(this.urlParams),
          params: JSON.parse(this.pagesParams),
        });
      } else if (this.loginWay === 'forgetPassword') {
        this.$router.replace({
          path: '/retrievePassword',
          query: JSON.parse(this.urlParams),
          params: JSON.parse(this.pagesParams),
        });
      }
    },

    // getCode() {
    //   const userPhone = String(this.userPhone);
    //   const isPhone = /^1[3-9]\d{9}$/g.test(userPhone);
    //   // this.isFlag = false;
    //   this.requestCode = false;
    //   clearInterval(this.timer);
    //   if (userPhone.length !== 11) return;

    //   if (isPhone) {
    //     this.$store.dispatch('saveUserPhone', userPhone);
    //     const result = queryCode({
    //       type: this.loginWay ? this.loginWay : 'login',
    //       phone: String(userPhone) || '',
    //     });
    //     result.then((data) => {
    //       if (data.code === 0) {
    //         this.isFlag = false;
    //         this.countDown();
    //       } else {
    //         this.isFlag = true;
    //         this.requestCode = true;
    //         this.residueTime = 59;
    //         clearInterval(this.timer);
    //         this.timer = null;
    //         Toast(data.msg);
    //       }
    //     });
    //   } else {
    //     Toast('请输入正确格式的手机号');
    //   }
    // },
    countDown() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.residueTime -= 1;
        if (this.residueTime <= 0) {
          this.isFlag = true;
          this.requestCode = true;
          this.residueTime = 59;
          clearInterval(this.timer);
          this.timer = null;
          sessionStorage.removeItem('codeTimer');
          sessionStorage.removeItem('forgetCodeTimer');
        }
      }, 1000);
    },
    Toast(msg) {
      Toast({
        message: msg,
        duration: 3 * 1000,
        position: 'top',
      });
    },
  },
  created() {
    const { userPhone } = this.$store.state;
    const { loginWay, fromPath } = this.$route.params;

    this.urlParams = window.localStorage.getItem('pagesQuery');
    this.pagesParams = window.localStorage.getItem('pagesParams');
    this.userPhone = userPhone;
    this.loginWay =
      loginWay ||
      JSON.parse(this.pagesParams)?.loginWay ||
      JSON.parse(this.pagesParams)?.type ||
      'login';
    if (JSON.parse(this.pagesParams)?.loginSource === 'yuntulogin') {
      this.yuntuColor = true;
    }
    if (fromPath) {
      this.isFlag = true;
      this.requestCode = true;
      this.residueTime = 59;
      clearInterval(this.timer);
      this.timer = null;
    } else {
      if (this.loginWay === 'forgetPassword' || this.loginWay === 'login' || this.pagesParams) {
        // this.isFlag = false;
        // this.requestCode = false;
        // this.countDown();
        // return;
        // 获取存储的倒计时信息
        let savedTimer = sessionStorage.getItem('codeTimer');
        if (this.loginWay === 'forgetPassword') {
          savedTimer = sessionStorage.getItem('forgetCodeTimer');
        }
        if (savedTimer) {
          const timerData = JSON.parse(savedTimer);
          if (timerData.phone === userPhone) {
            const remainTime = Math.ceil((timerData.endTime - Date.now()) / 1000);
            if (remainTime > 0) {
              // 继续之前的倒计时
              this.isFlag = false;
              this.requestCode = false;
              this.residueTime = remainTime;
              this.countDown();
            }
          }
        }
      }

      this.getCodeBtn();
    }
  },
  mounted() {
    document.getElementsByClassName('app')[0].setAttribute('style', 'background-color:#fff');
  },
  beforeDestroy() {
    document.getElementsByClassName('app')[0].removeAttribute('style');
    clearInterval(this.timer);
    this.timer = null;
  },

  beforeCreate() {},
};
</script>
<style lang="scss" scoped>
.getCode {
  .getCodeMain {
    .getCodeMain_title {
      padding-top: 89px;
      color: #333;
      font-weight: 500;
      font-size: 51px;
      line-height: 72px;
    }

    .getCodeMain_describe {
      margin: 20px 0 94px 0;
      color: #787878;
      font-weight: 400;
      font-size: 29px;
      line-height: 40px;
    }
  }

  .resetGetCode {
    position: relative;
    width: 100%;
    height: 100px;

    .getCodeText {
      position: absolute;
      top: 34px;
      right: 0.72rem;
      width: 214px;
      height: 54px;
      color: #fff;
      font-size: 25px;
      line-height: 54px;
      text-align: center;
      background-color: #a5a5a5;
      border-radius: 0.07rem;
    }

    .activeClass {
      position: absolute;
      top: 34px;
      right: 0.72rem;
      width: 141px;
      height: 54px;
      color: #fff;
      font-size: 25px;
      line-height: 54px;
      text-align: center;
      background-color: #ff6c02;
      border-radius: 0.07rem;
    }

    .idNone {
      display: none;
    }
  }
}

.yuntuColor {
  .activeClass {
    background-color: $yuntuColor !important;
  }
}
</style>
